module.exports = __webpack_public_path__ + "static/media/download.9390fb01.svg";